import React from "react";

const Footer = () => {
  const isAstronomy = window.location.pathname === "/astronomy";

  return (
    <div className={`footer${isAstronomy ? " footer-astronomy" : ""}`}>
      <div className="footer-social-icons">
        <a href="https://www.github.com/kuhuk" target="_blank" rel="noreferrer" aria-label="GitHub">
          <span className="footer-social-icon icon-github" />
        </a>
        <a href="https://www.instagram.com/astro_kuhuk/" target="_blank" rel="noreferrer" aria-label="Instagram">
          <span className="footer-social-icon icon-instagram" />
        </a>
        <a href="https://www.linkedin.com/in/kuhuk/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
          <span className="footer-social-icon icon-linkedin" />
        </a>
        <a href="https://www.facebook.com/sharma.kuhuk/" target="_blank" rel="noreferrer" aria-label="Facebook">
          <span className="footer-social-icon icon-facebook" />
        </a>
        <a href="https://twitter.com/astro_kuhuk/" target="_blank" rel="noreferrer" aria-label="Twitter">
          <span className="footer-social-icon icon-twitter" />
        </a>
      </div>

      <p className="footer-tagline">made with ♥️ by kuhuk</p>
      <p className="footer-copyright">© {new Date().getFullYear()} Kuhuk Sharma</p>
    </div>
  );
};

export default Footer;
